import React, { Component }                 from 'react';
import urlHandler                           from '../../utils/urlHandler';
import UserManual                           from '../../styles/docs/FFT_DemoUserGuide.pdf';
import DatePicker                           from 'react-datepicker';
import moment                               from 'moment';
import session                              from '../../utils/session';
import loader                               from '../../styles/images/loader.gif';
import perms                                from '../../utils/permissions';
import history                              from '../../utils/history';

import { Charts, ChartContainer, 
         ChartRow, YAxis, BarChart, 
         styler, Resizable, LineChart, 
         ScatterChart }                     from 'react-timeseries-charts';

import { TimeSeries, Index, TimeRange }     from 'pondjs';
import { format }                           from 'd3-format';

class UsageControl extends Component {
    constructor(props){
        super(props);

        this.onChangeUser = this.onChangeUser.bind(this);
        this.onChangeBeginDate = this.onChangeBeginDate.bind(this);
        this.onChangeEndDate = this.onChangeEndDate.bind(this);
        this.onChangeEndpoint = this.onChangeEndpoint.bind(this);
        this.onChangeEnvironment = this.onChangeEnvironment.bind(this);
        this.onChangeMetric = this.onChangeMetric.bind(this);
        this.onChangeInterval = this.onChangeInterval.bind(this);
        this.setUserDefaults = this.setUserDefaults.bind(this);
        this.onTimeRangeChanged = this.onTimeRangeChanged.bind(this);
        this.onHighlightChange = this.onHighlightChange.bind(this);
        this.onMouseNear = this.onMouseNear.bind(this);
        this.getUsageData = this.getUsageData.bind(this);

        this.state = {
            begin: null,
            end: null,
            users: [],
            endpoints: [],
            environments: [],
            metrics: {
                averageResponseTime: {
                    unit: 'ms'
                },
                averageResponseSize: {
                    unit: 'bytes'
                },
                averageRequestSize: {
                    unit: 'bytes'
                },
                maxRequestSize: {
                    unit: 'bytes'
                },
                maxResponseSize: {
                    unit: 'bytes'
                },
                maxResponseTime: {
                    unit: 'ms'
                },
                minRequestSize: {
                    unit: 'bytes'
                },
                minResponseSize: {
                    unit: 'bytes'
                },
                minResponseTime: {
                    unit: 'ms'
                }
            },
            intervals: [
                'hourly',
                'daily'
            ],
            usage: null,
            timeRange: null,
            highlight: null,
            metricHighlight: null,
            selectedInterval: 'hourly',
            error: null,
            loading: false
        }
    }

    componentDidMount() {

        const usagePermission = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_USAGE);
        if (!usagePermission){
            history.push('/')
        } else{
            // Get initial data for last 30 days
            var end = moment.utc();
            var begin = moment().utc().subtract(30,'d');
    
            this.getUsageData(begin, end);
        }
    }

    getUsageData(begin, end, user=null) {

        var endStr = end.format('YYYY-MM-DD') + 'T23:59:59Z';
        var beginStr = begin.format('YYYY-MM-DD') + 'T00:00:00Z';
        
        this.setState({
            loading: true
        })

        urlHandler.sendUsageRequest(beginStr, endStr, 'hourly', 'account', null, (resp, status) => {
            if (status == 200) {
                if ('usage' in resp) {
                    if (user) {
                        if (user in resp['usage']) {
                            this.setUserDefaults(user, 
                                resp['usage'], 
                                begin, 
                                end,                                
                                this.state.selectedEnvironment ? this.state.selectedEnvironment : null,
                                this.state.selectedEndpoint ? this.state.selectedEndpoint : null);
                        } else {
                            // The user does not have any usage data for this call
                            this.setState({
                                begin,
                                end,
                                selectedUser: user,
                                selectedTransactions: {},
                                usage: resp['usage'],
                                timeRange: new TimeRange([moment.utc(begin), moment.utc(end)]),
                                loading: false
                            })
                        }
                    } else {
                        var users = Object.keys(resp['usage']);
                        if (users.length > 0) {
                            var selectedUser = users[0];
                            if (users.indexOf(session.getUserName()) != -1) {
                                selectedUser = session.getUserName();
                            }
                            this.setUserDefaults(selectedUser, 
                                resp['usage'], 
                                begin, 
                                end,
                                this.state.selectedEnvironment ? this.state.selectedEnvironment : null,
                                this.state.selectedEndpoint ? this.state.selectedEndpoint : null);
                        }
                    }
                } else {
                    // There is no usage for this call
                    this.setState({
                        begin,
                        end,
                        users: [ session.getUserName() ],
                        selectedUser: user ? user : session.getUserName(),
                        selectedTransactions: {},
                        usage: null,
                        timeRange: new TimeRange([moment.utc(begin), moment.utc(end)]),
                        loading: false

                    })
                }
            } else {
                console.log('Error calling sendUsageRequest => ', resp);       
                this.setState({
                    endpoints: [],
                    environments: [],
                    usage: null,
                    loading: false
                })     
            }
        });            
    }

    setUserDefaults(user, usage, begin, end, env=null, endpoint=null) {
        if (user in usage && 'environments' in usage[user]) {
            var environments = Object.keys(usage[user]['environments'])
            if (environments.length > 0) {
                var selectedEnvironment = environments[0];
                if (env && environments.indexOf(env) != -1) {
                    selectedEnvironment = env;
                }

                if ('endpoints' in usage[user]['environments'][selectedEnvironment]) {
                    var endpoints = Object.keys(usage[user]['environments'][selectedEnvironment]['endpoints']);
                    if (endpoints.length > 0) {
                        var selectedEndpoint = endpoints[0];
                        if (endpoint && endpoints.indexOf(endpoint) != -1) {
                            selectedEndpoint = endpoint;
                        }

                        var selectedTransactions = null;
                        if ('transactionSummaries' in usage[user]['environments'][selectedEnvironment]['endpoints'][selectedEndpoint]) {
                            selectedTransactions = usage[user]['environments'][selectedEnvironment]['endpoints'][selectedEndpoint]['transactionSummaries'];
                        }

                        this.setState({
                            begin,
                            end,
                            users: this.state.users.length > 0 ? this.state.users: Object.keys(usage),
                            endpoints,
                            environments,
                            selectedUser: user,
                            selectedEnvironment,
                            selectedEndpoint,
                            selectedTransactions,
                            usage,
                            timeRange: new TimeRange([moment.utc(begin), moment.utc(end)]),
                            loading: false
                        })
                    }
                }
            }
        }
    }

    onChangeUser() {
        this.setState({
            selectedUser: this.refs.user.value
        }, () => {
            this.getUsageData(this.state.begin, this.state.end, this.state.selectedUser);
        })
    }

    onChangeBeginDate(date) {
        if (date) {
            var date = moment(date);
            if (date > this.state.end) {
                this.setState({
                    error: 'Invalid begin date selected.',
                    begin: null,
                    usage: null,
                    selectedTransactions: null
                });
            } else {
                this.setState({
                    begin: moment(date.format('YYYY-MM-DD'), 'YYYY-MM-DD'),
                    error: null
                }, () => {
                    this.getUsageData(this.state.begin, this.state.end, this.refs.user.value)
                })
            }
        }
    }

    onChangeEndDate(date) {
        if (date) {
            var date = moment(date);
            if (date < this.state.begin) {
                this.setState({
                    error: 'Invalid end date selected.',
                    end: null,
                    usage: null,
                    selectedTransactions: null
                });
            } else {
                this.setState({
                    end: moment(date.format('YYYY-MM-DD'), 'YYYY-MM-DD'),
                    error: null
                }, () => {
                    this.getUsageData(this.state.begin, this.state.end, this.refs.user.value)
                })
            }
        }
    }

    onChangeInterval() {
        this.setState({
            selectedInterval: this.refs.interval.value
        }, () => {
            this.getUsageData(this.state.begin, this.state.end, this.state.selectedUser);
        })     
    }

    onChangeEndpoint() {
        this.setState({
            selectedEndpoint: this.refs.endpoint.value
        },() => {
            this.getUsageData(this.state.begin, this.state.end, this.state.selectedUser);
        })
    }

    onChangeEnvironment() {
        this.setState({
            selectedEnvironment: this.refs.environment.value
        },() => {
            this.getUsageData(this.state.begin, this.state.end, this.state.selectedUser);
        })
    }

    onChangeMetric() {
        this.setUserDefaults(this.refs.user.value, this.state.usage, this.state.begin, this.state.end, this.refs.environment.value, this.refs.endpoint.value);
    }

    onTimeRangeChanged(range) {
        this.setState({ timeRange: range });
    }

    onHighlightChange(highlight) {
        this.setState({
            highlight
        })
    }

    onMouseNear(point) {
        this.setState({
            metricHighlight: point
        })
    }

    render() {   

        var series = null;
        var metricSeries = null;
        var totalCalls = 0;

        if (this.state.selectedTransactions) {

            // Calculate transaction count data used for the bar graph
            var data = [];
            var maxY = 0;
            var indexGenerator = '1d';
            for (var key in this.state.selectedTransactions) {
                if (this.state.selectedInterval === 'hourly') {
                    indexGenerator = '1h';
                    if (key.match(/^\d/)) {
                        if (this.state.selectedTransactions[key]['transactionCount'] > maxY) {
                            maxY = this.state.selectedTransactions[key]['transactionCount'];
                        }
                        data.push([key, this.state.selectedTransactions[key]['transactionCount']])
                    } else if (key.match(/^Total/)) {
                        totalCalls = this.state.selectedTransactions[key]['transactionCount'];
                    }
                } else {
                    if (key.match(/^Daily/)) {
                        if (this.state.selectedTransactions[key]['transactionCount'] > maxY) {
                            maxY = this.state.selectedTransactions[key]['transactionCount'];
                        }
                        var dailyDate = key.match(/^Daily Total (.+)/)[1] + 'T00:00:00Z';
                        data.push([dailyDate, this.state.selectedTransactions[key]['transactionCount']])
                    } else if (key.match(/^Total/)) {
                        totalCalls = this.state.selectedTransactions[key]['transactionCount'];
                    }
                }
            }

            if (data.length > 0) {
                series = new TimeSeries({
                    name: 'call_values',
                    columns: ['index', 'calls'],
                    points: data.map(([d, value]) => {
                        return [
                            Index.getIndexString(indexGenerator, moment.utc(d, 'YYYY-MM-DDTHH:mm:ssZ').toDate()),
                            value
                        ]
                    })
                });
            }

            // Calculate the metric data used in the line graph. This is based on the selected metric.
            var metricData = [];
            var maxY2 = 0;
            var metric = this.refs.metric.value;
            for (var key in this.state.selectedTransactions) {
                if (this.state.selectedInterval === 'hourly') {
                    if (key.match(/^\d/)) {
                        if (this.state.selectedTransactions[key][metric] > maxY2) {
                            maxY2 = this.state.selectedTransactions[key][metric];
                        }
                        metricData.push([key, this.state.selectedTransactions[key][metric]])
                    }
                } else {
                    if (key.match(/^Daily/)) {
                        if (this.state.selectedTransactions[key][metric] > maxY2) {
                            maxY2 = this.state.selectedTransactions[key][metric];
                        }
                        var dailyDate = key.match(/^Daily Total (.+)/)[1] + 'T00:00:00Z';
                        metricData.push([dailyDate, this.state.selectedTransactions[key][metric]])
                    }
                }
            }

            if (metricData.length > 0) {
                metricSeries = new TimeSeries({
                    name: 'metric_values',
                    columns: ['index', 'metric'],
                    points: metricData.map(([d, value]) => {
                        return [
                            Index.getIndexString(indexGenerator, moment.utc(d, 'YYYY-MM-DDTHH:mm:ssZ').toDate()),
                            value
                        ]
                    })
                });
            }
        }

        const highlight = this.state.highlight;
        var formatter = format('d');
        let infoValues = [];
        if (highlight) {
            infoValues = [
                { label: 'Calls', value: formatter(highlight.event.get(highlight.column))}, 
            ];
        }

        const metricHighlight = this.state.metricHighlight;
        formatter = format(',.2f');
        let metricInfoValues = [];
        if (metricHighlight) {
            metricInfoValues = [
                {   
                    label: this.refs.metric.value, 
                    value: formatter(metricHighlight.event.get(metricHighlight.column)) + ' ' + this.state.metrics[this.refs.metric.value].unit
                }, 
            ];
        }

        const style = styler([
            { key: 'calls', color: '#9fd277'},
            { key: 'metric', color: '#00a2ae', width: 2 }
        ]);

        return (
            <div className='usagecontrol-wrapper'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <span>
                                    <h1 className='heading-1' style={{float: 'left', marginBottom: '25px'}}>API Usage</h1>
                                    <span style={{float: 'right'}}>
                                        <a href={ UserManual } target='__blank' download='FFT_DemoUserManual.pdf'> 
                                            <span className='fa fa-file-pdf-o'>&nbsp;</span> 
                                            User Manual 
                                        </a> 
                                    </span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className='usage-user-form form-field-wrapper text-field'>
                                                <label className='form-label'>User:</label>
                                                <select className='form-field usage-user-form-field'
                                                        ref='user'
                                                        //value={this.state.summaryModel}
                                                        onChange={this.onChangeUser}>
                                                    {this.state.users.map((user) => {
                                                        return <option key={user.trim()} value={user.trim()}>{user.trim()}</option>
                                                    })}
                                                </select>
                                            </td>
                                            <td className='usage-other-form form-field-wrapper text-field'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label className='form-label'>Begin:</label>
                                                                <DatePicker className='form-field usage-begin-form-field'
                                                                    ref='beginDate'
                                                                    selected={this.state.begin ? this.state.begin.toDate() : undefined}
                                                                    onChange={this.onChangeBeginDate}
                                                                    placeholderText='Click to select'
                                                                    dateFormat='yyyy-MM-dd'
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode='select'
                                                                />
                                                            </td>
                                                            <td>
                                                                <label className='form-label'>End:</label>
                                                                <DatePicker className='form-field usage-end-form-field'
                                                                    ref='endDate'
                                                                    selected={this.state.end ? this.state.end.toDate() : undefined}
                                                                    onChange={this.onChangeEndDate}
                                                                    placeholderText='Click to select'
                                                                    dateFormat='yyyy-MM-dd'
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode='select'
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label className='form-label'>Environment:</label>
                                                                <select className='form-field usage-endpoint-form-field'
                                                                        ref='environment'
                                                                        value={this.state.selectedEnvironment}
                                                                        onChange={this.onChangeEnvironment}>
                                                                    {this.state.environments.map((env) => {
                                                                        return <option key={env.trim()} value={env.trim()}>{env.trim()}</option>
                                                                    })}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <label className='form-label'>Endpoint:</label>
                                                                <select className='form-field usage-endpoint-form-field'
                                                                        ref='endpoint'
                                                                        value={this.state.selectedEndpoint}
                                                                        onChange={this.onChangeEndpoint}>
                                                                    {this.state.endpoints.map((endpoint) => {
                                                                        return <option key={endpoint.trim()} value={endpoint.trim()}>{endpoint.trim()}</option>
                                                                    })}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label className='form-label'>Interval:</label>
                                                                <select className='form-field usage-interval-form-field'
                                                                        ref='interval'
                                                                        value={this.state.selectedInterval}
                                                                        onChange={this.onChangeInterval}>
                                                                    {this.state.intervals.map((int) => {
                                                                        return <option key={int.trim()} value={int.trim()}>{int.trim()}</option>
                                                                    })}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <label className='form-label'>Metric:</label>
                                                                <select className='form-field usage-metric-form-field'
                                                                        ref='metric'
                                                                        //value={this.state.summaryModel}
                                                                        onChange={this.onChangeMetric}>
                                                                    {Object.keys(this.state.metrics).map((metric) => {
                                                                        return <option key={metric.trim()} value={metric.trim()}>{metric.trim()}</option>
                                                                    })}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                {this.state.error &&
                                                    <div className="usagecontrol-error">
                                                        {this.state.error}
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            {this.state.loading ?
                                <td className="usagecontrol-loading">
                                    <img src={loader}/>
                                </td>
                            : 
                                <td>
                                    <div style={{paddingTop: '30px'}}>
                                        <table className="usagecontrol-graph">
                                            <tbody>
                                                <tr>
                                                    <td className="title">
                                                        Usage for {this.state.selectedUser} 
                                                        {this.state.selectedEnvironment && 
                                                            <span> ({this.state.selectedEnvironment})</span>                                                  
                                                        }
                                                        <br/>
                                                    </td>
                                                    <td>
                                                        {this.state.begin && this.state.end && 
                                                        <table className="total">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="total-header">
                                                                        Totals for {this.state.begin.format('YYYY-MM-DD')} to {this.state.end.format('YYYY-MM-DD')}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="total-stats">
                                                                        <span className="key">Transactions:</span> {parseInt(totalCalls).toLocaleString()}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {series ?
                                        <Resizable>
                                            <ChartContainer 
                                                timeRange={this.state.timeRange} 
                                                enablePanZoom={true}
                                                onTimeRangeChanged={this.onTimeRangeChanged}
                                                utc={true}
                                                timeAxisStyle={{
                                                    values: {
                                                        'font-weight': '200', 
                                                        'font-size': '14'    
                                                    }
                                                }}>
                                                <ChartRow height="450">
                                                    <YAxis
                                                        id='volume'
                                                        label='Number Of Calls (Transactions)'
                                                        min={0}
                                                        max={maxY}
                                                        width='90'
                                                        labelOffset={-38}
                                                        format=",d"
                                                        type='linear'
                                                        style={{
                                                            label: { 
                                                                'font-weight': '200', 
                                                                'font-size': '15'
                                                            },
                                                            values: {
                                                                'font-weight': '200', 
                                                                'font-size': '14'    
                                                            }
                                                        }}
                                                    />
                                                    <Charts>
                                                        <BarChart
                                                            axis='volume'
                                                            style={style}
                                                            spacing={2}
                                                            size={ this.state.selectedInterval==='daily' ? 10 : null}
                                                            columns={['calls']}
                                                            series={series}
                                                            info={infoValues}
                                                            infoHeight={30}
                                                            infoWidth={100}
                                                            infoOffsetY={10}
                                                            infoTimeFormat={ (index) => {
                                                                if (this.state.selectedInterval === 'daily') {
                                                                    return moment(index.begin()).utc().format('L') 
                                                                }
                                                                return moment(index.begin()).utc().format('L LTS')
                                                            }}
                                                            onHighlightChange={this.onHighlightChange}
                                                            highlighted={this.state.highlight}
                                                        />
                                                        {metricSeries && 
                                                        <LineChart 
                                                            axis='metric' 
                                                            series={metricSeries} 
                                                            columns={['metric']}
                                                            style={style}/>
                                                        }
                                                        {metricSeries &&
                                                        <ScatterChart 
                                                            axis='metric' 
                                                            series={metricSeries} 
                                                            columns={['metric']}
                                                            style={style}
                                                            info={metricInfoValues}
                                                            infoHeight={30}
                                                            infoWidth={195}
                                                            infoOffsetY={20}
                                                            infoTimeFormat={ (index) => {
                                                                if (this.state.selectedInterval === 'daily') {
                                                                    return moment(index.begin()).utc().format('YYYY-MM-DD') 
                                                                }
                                                                return moment(index.begin()).utc().format('YYYY-MM-DD HH:mm:ss')
                                                            }}
                                                            onMouseNear={this.onMouseNear}
                                                            highlight={this.state.metricHighlight}
                                                        />
                                                        }
                                                    </Charts>
                                                    {metricSeries &&
                                                    <YAxis
                                                        id='metric'
                                                        label={this.refs.metric.value + ' (' + this.state.metrics[this.refs.metric.value].unit + ')'}
                                                        min={0}
                                                        max={maxY2}
                                                        width='120'
                                                        labelOffset={58}
                                                        format=",.2f"
                                                        type='linear'
                                                        style={{
                                                            label: { 
                                                                'font-weight': '200', 
                                                                'font-size': '15'
                                                            },
                                                            values: {
                                                                'font-weight': '200', 
                                                                'font-size': '14', 
                                                            }
                                                        }}
                                                    />
                                                    }
                                                </ChartRow>
                                            </ChartContainer>
                                        </Resizable>
                                        :
                                            <span className="usagecontrol-error">No data during selected time period.</span>
                                        }
                                    </div>
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default UsageControl;
